// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__sT11k","avtiveTab":"Tabs_avtiveTab__tK-2-"};